module.exports = __webpack_public_path__ + "img/couples-017.5244a41d.jpg";